import cn from "@/utils/cn"
import { LocalDate } from "@js-joda/core"
import { ComponentPropsWithoutRef } from "react"

const appVersion = import.meta.env.VITE_APP_VERSION as string
const date = LocalDate.now()
const currentYear = date.year()

type AppInfoFooterProps = Omit<ComponentPropsWithoutRef<"footer">, "children">

const AppInfoFooter = ({ className, ...otherProps }: AppInfoFooterProps) => (
  <footer
    className={cn(
      "shrink-0 text-center text-sm text-primary/60",
      className
    )}
    {...otherProps}
  >
    <p>
      © {currentYear} <strong className="font-semibold">Bloomlife</strong>. All
      rights reserved.
    </p>
    <p>Version {appVersion}</p>
  </footer>
)

export default AppInfoFooter
